import { CANONICAL_SIGNAL_TYPE_VALUES, SIGNAL_TYPE_REGISTRY } from './signal-type-registry.js';

// SIGNAL_TYPE_VALUES / SignalType are the canonical observation-layer vocabulary
// (re-exported from the registry). SIGNAL_TYPE_DEFINITIONS is derived from the
// registry so labels/descriptions cannot drift from the single source of truth.
export const SIGNAL_TYPE_VALUES = CANONICAL_SIGNAL_TYPE_VALUES;
export type SignalType = (typeof SIGNAL_TYPE_VALUES)[number];

export interface SignalTypeDefinition {
  value: SignalType;
  label: string;
  description: string;
}

export const SIGNAL_TYPE_DEFINITIONS: readonly SignalTypeDefinition[] =
  CANONICAL_SIGNAL_TYPE_VALUES.map((value) => ({
    value,
    label: SIGNAL_TYPE_REGISTRY[value].label,
    description: SIGNAL_TYPE_REGISTRY[value].description,
  }));
